module.exports = __webpack_public_path__ + "img/color-wheel-areas.b76d19c0.png";